export default {
  methods: {
    getPriceChangeClass(number) {
      return 'price_' + (number > 0 ? 'up' : number < 0 ? 'down' : 'init')
    },
  },
}
